import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-verify",
  "use": "icon-verify-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-verify\">\r\n  <defs>\r\n    <style type=\"text/css\"></style>\r\n  </defs>\r\n  <path d=\"M639.531236 1019.430684l245.896533-248.153884-245.896533 0.291271L639.531236 1019.430684zM639.531236 1019.430684\" p-id=\"1420\" />\r\n  <path d=\"M750.733084 0 164.923164 0 23.274382 0l0 215.076409 0 804.37248 141.648782 0 409.172196 0L574.09536 706.277831l176.637724 0 141.648782 0 0-50.54464L892.381867 509.515093l0-70.61504L892.381867 292.026596l0-76.950187L892.381867 0 750.733084 0 750.733084 0zM164.923164 729.160818l0-73.436729 227.956053 0 0 73.436729L164.923164 729.160818 164.923164 729.160818zM750.733084 509.515093 164.923164 509.515093l0-70.61504 585.80992 0L750.733084 509.515093 750.733084 509.515093zM750.733084 292.026596 164.923164 292.026596l0-76.950187 585.80992 0L750.733084 292.026596 750.733084 292.026596zM750.733084 292.026596\" p-id=\"1421\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/verify.svg
// module id = eoik
// module chunks = 60